import { render, staticRenderFns } from "./RobDescription.vue?vue&type=template&id=6d99c538&scoped=true"
import script from "./RobDescription.vue?vue&type=script&lang=js"
export * from "./RobDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d99c538",
  null
  
)

export default component.exports